"use strict";

require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.string.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BudgetUtils = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.math.trunc.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.slice.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../../common/utils");
var _constants = require("../../../common/requestDetails/constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var COST_ATTRIBUTE = 'cost';
var INDIRECT_CHARGES_BOCS = ['indirectCharges'];
var INVESTMENT = 'investment';
var MANAGEMENTCOSTS = 'managementCosts';
var RATE_PRECISION = 10;

// Program Income methods
var PI_DEDUCTION = 'DeductionFromTotalCosts';
var PI_APPLICATION_TO_NON_FEDSHARE = 'ApplicationToNonFedShare';
var PI_ADDITION = 'AdditionToAward';
var PI_NOT_ALLOWED = 'ProgramIncomeNotAllowed';
var BudgetUtils = {
  getDefaultAppShare: function getDefaultAppShare(config, bocs, fundingStreams, appShareRates, rateAppliesTo, constructionProgramIncome, programIncome, foHandleProgIncome) {
    var numPeriods = _lodash.default.max(_lodash.default.map(_lodash.default.values(appShareRates), function (rates) {
      return rates.length;
    }));
    var applicantShareByPeriod = [];
    var isPIApplied = false; // Program Income (PI) needs to be applied once

    _lodash.default.forEach(fundingStreams, function (fundingStream) {
      var itemBocCharges = BudgetUtils.collectCosts(_lodash.default.fill(Array(numPeriods), []), fundingStream);
      var bocTotals = BudgetUtils.sumBocTotals(numPeriods, bocs, itemBocCharges, constructionProgramIncome);
      var totalsByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, bocs);
      var incomeTotal;
      if (_lodash.default.isArray(programIncome)) {
        incomeTotal = 0;
        for (var i = 0; i < programIncome.length; i++) {
          incomeTotal = incomeTotal + _lodash.default.toNumber(programIncome[i]);
        }
      }
      if (!isPIApplied && !(foHandleProgIncome == null) && !_lodash.default.isEqual(foHandleProgIncome, PI_APPLICATION_TO_NON_FEDSHARE) && !(programIncome == null && (programIncome <= 0 || incomeTotal != undefined))) {
        var updatedApplicantShareByPeriod = BudgetUtils.getUpdatedTotalsByPeriod(totalsByPeriod, foHandleProgIncome, programIncome);
        totalsByPeriod = updatedApplicantShareByPeriod;
        isPIApplied = true;
      }
      var fundingStreamAppShare = BudgetUtils.getShareByPeriod(totalsByPeriod, _lodash.default.get(appShareRates, fundingStream.fundingStreamType), _lodash.default.get(rateAppliesTo, fundingStream.fundingStreamType, rateAppliesTo));
      _lodash.default.forEach(fundingStreamAppShare, function (periodAppShare, period) {
        var appShare = _lodash.default.get(applicantShareByPeriod, period, 0);
        if (period === numPeriods - 1 && _lodash.default.isEqual(foHandleProgIncome, PI_APPLICATION_TO_NON_FEDSHARE) && !isPIApplied && !_lodash.default.isArray(programIncome)) {
          var updatedLastAppShare = (0, _utils.safeSubstract)(periodAppShare, programIncome);
          _lodash.default.set(applicantShareByPeriod, period, updatedLastAppShare);
          isPIApplied = true;
        } else if (_lodash.default.isEqual(foHandleProgIncome, PI_APPLICATION_TO_NON_FEDSHARE) && !isPIApplied && _lodash.default.isArray(programIncome)) {
          var _updatedLastAppShare = (0, _utils.safeSubstract)(periodAppShare, _lodash.default.toNumber(programIncome[period]));
          _lodash.default.set(applicantShareByPeriod, period, _updatedLastAppShare);
          if (period === numPeriods - 1) {
            isPIApplied = true;
          }
        } else {
          _lodash.default.set(applicantShareByPeriod, period, (0, _utils.safeAdd)(appShare, periodAppShare));
        }
      });
    });
    return applicantShareByPeriod;
  },
  computeBudgetFromFedRates: function computeBudgetFromFedRates(bocs, fundingStreams, fedRates, rateAppliesTo, constructionProgramIncome, managementCostItemCodes) {
    var numPeriods = _lodash.default.size(fedRates);
    var budgetSummary = BudgetUtils.computeBudgetSummary(bocs, fundingStreams, numPeriods, constructionProgramIncome, managementCostItemCodes);
    var fedShare;
    var appShare;
    if (rateAppliesTo === 'federal') {
      var appRates = _lodash.default.map(fedRates, function (rate) {
        return (0, _utils.safeSubstract)(1, rate);
      });
      appShare = BudgetUtils.getShareByPeriod(budgetSummary.totalCharges, appRates, rateAppliesTo);
      fedShare = _lodash.default.map(appShare, function (appPeriodTotal, i) {
        return (0, _utils.safeSubstract)(_lodash.default.get(budgetSummary.totalCharges, i), appPeriodTotal);
      });
    } else {
      fedShare = BudgetUtils.getShareByPeriod(budgetSummary.totalCharges, fedRates, rateAppliesTo);
      appShare = BudgetUtils.getShareByPeriod(budgetSummary.totalCharges, _lodash.default.map(fedRates, function (rate) {
        return (0, _utils.safeSubstract)(1, rate);
      }), rateAppliesTo);
    }
    return {
      budgetSummary: budgetSummary,
      share: {
        fedShare: fedShare,
        appShare: appShare
      }
    };
  },
  completeBudgetFromDataRules: function completeBudgetFromDataRules(params) {
    var bocs = params.bocs,
      fundingStreams = params.fundingStreams,
      foConfig = params.foConfig,
      data = params.data,
      costShareRules = params.recipientCostShareRules,
      useRoundUpLogic = params.useRoundUpLogic,
      budgetCalculationMode = params.budgetCalculationMode,
      rateAppliesTo = params.rateAppliesTo,
      constructionProgramIncome = params.constructionProgramIncome,
      programIncome = params.programIncome,
      foHandleProgIncome = params.foHandleProgIncome;
    var budgetSummaryParams = {
      bocs: bocs,
      fundingStreams: fundingStreams,
      foConfig: foConfig,
      rateAppliesTo: rateAppliesTo ? rateAppliesTo : 'federal',
      useRoundUpLogic: useRoundUpLogic,
      budgetCalculationMode: budgetCalculationMode,
      constructionProgramIncome: constructionProgramIncome,
      programIncome: programIncome,
      foHandleProgIncome: foHandleProgIncome
    };
    var findIneligibleRule = function findIneligibleRule(calcRules) {
      var index = _lodash.default.indexOf(calcRules, function (calc) {
        return !_lodash.default.get(calc, 'isEligible', true);
      });
      return index ? calcRules[index] : null;
    };
    var getDefaultPercentValue = function getDefaultPercentValue(rules) {
      var defaultPercentValue;
      _lodash.default.each(rules, function (ruleToApply) {
        defaultPercentValue = parseFloat(_lodash.default.get(ruleToApply, 'defaultPercentValue'));
      });
      return defaultPercentValue;
    };
    var getCalcRulesToApply = function getCalcRulesToApply(rules, data) {
      var calcRules = [];
      _lodash.default.each(rules, function (ruleToApply) {
        if (!_lodash.default.isEmpty(ruleToApply.calculationRules)) {
          _lodash.default.each(ruleToApply.calculationRules, function (calcRule) {
            var dataValue = _lodash.default.get(data, calcRule.ifDataPath);
            var values = _lodash.default.get(calcRule, 'values');
            var range = _lodash.default.get(calcRule, 'range');
            var fedShareLimit = _lodash.default.toNumber(_lodash.default.get(calcRule, 'fedShareLimit'));
            // for {effectiveTimePeriodType: whole} reductions
            var reductionVals = _lodash.default.get(calcRule, 'reductions');
            // Add all calculations and fer share limit
            if (!_lodash.default.isEmpty(values) && _lodash.default.indexOf(values, dataValue) > -1) {
              calcRules.push(calcRule);
            } else if (!_lodash.default.isEmpty(range)) {
              // Array with low and maybe high
              var intValue = _lodash.default.parseInt(dataValue);
              var low = _lodash.default.parseInt(_lodash.default.get(range, 0));
              var high = _lodash.default.parseInt(_lodash.default.get(range, 1));
              if (intValue && intValue >= low && (_lodash.default.isNaN(high) || intValue <= high)) {
                calcRules.push(calcRule);
              }
            } else if (!_lodash.default.isNaN(fedShareLimit) || !_lodash.default.isEmpty(reductionVals)) {
              calcRules.push(calcRule);
            }
          });
        }
      });
      return calcRules;
    };
    var getRulesToApply = function getRulesToApply(costShareRules, data) {
      var rules = [];
      _lodash.default.each(costShareRules, function (rule) {
        var path = rule.ifDataPath;
        if (path) {
          if ((0, _utils.contains)(rule.equalValues, _lodash.default.get(data, path))) {
            rules.push(rule);
          }
        } else {
          rules.push(rule);
        }
      });
      return rules;
    };
    var getCalculations = function getCalculations(calcRules) {
      return _lodash.default.reduce(calcRules, function (result, calc) {
        var limit = _lodash.default.toNumber(_lodash.default.get(calc, 'fedShareLimit'));
        var limitMessage = _lodash.default.get(calc, 'message');
        if (!_lodash.default.isNaN(limit)) {
          result.fedShareLimit = limit;
          result.limitMessage = limitMessage;
          result.applyCappedToAppShare = _lodash.default.get(calc, 'applyCappedToAppShare', false);
        }
        var percentage = parseFloat(_lodash.default.get(calc, 'percentValue'));
        if (!_lodash.default.isNaN(percentage)) {
          result.percentageValue = percentage;
        }
        var reductions = _lodash.default.get(calc, 'reductions');
        if (!_lodash.default.isEmpty(reductions)) {
          result.reductions = reductions;
        }
        return result;
      }, {});
    };
    var applyCalculations = function applyCalculations(calculations, defaultPercentValue, budgetSummaryParams, data) {
      var isFedSharePastLimit = function isFedSharePastLimit(fedShareLimit, fedShareValue) {
        return (fedShareLimit || fedShareLimit === 0) && fedShareValue > fedShareLimit;
      };
      var getNumberofPeriods = function getNumberofPeriods(foConfig, fundingStreams) {
        var configFundingStreams = [];
        _lodash.default.forEach(fundingStreams, function (fundingStream) {
          var index = _lodash.default.findIndex(foConfig, function (configFundingStream) {
            return configFundingStream.fundingStreamType == fundingStream.fundingStreamType;
          });
          configFundingStreams.push(foConfig[index]);
        });
        var configFundingStream = _lodash.default.reduce(configFundingStreams, function (currentFundingStream, nextFundingStream) {
          var currentApplicantShare = _lodash.default.get(currentFundingStream, 'applicantCostShareRate');
          var nextApplicantShare = _lodash.default.get(nextFundingStream, 'applicantCostShareRate');
          return _lodash.default.size(currentApplicantShare) > _lodash.default.size(nextApplicantShare) ? currentFundingStream : nextFundingStream;
        });
        var periodType = _lodash.default.get(configFundingStream, 'effectiveTimePeriodType');
        var applicantCostShareRate = _lodash.default.get(configFundingStream, 'applicantCostShareRate');
        return periodType == 'whole' ? 1 : _lodash.default.size(applicantCostShareRate);
      };
      var bocs = budgetSummaryParams.bocs,
        fundingStreams = budgetSummaryParams.fundingStreams,
        foConfig = budgetSummaryParams.foConfig,
        useRoundUpLogic = budgetSummaryParams.useRoundUpLogic,
        budgetCalculationMode = budgetSummaryParams.budgetCalculationMode,
        constructionProgramIncome = budgetSummaryParams.constructionProgramIncome,
        managementCostItemCodes = budgetSummaryParams.managementCostItemCodes,
        programIncome = budgetSummaryParams.programIncome,
        foHandleProgIncome = budgetSummaryParams.foHandleProgIncome;
      var appShare = [];
      var fedShare = [];
      var fedRate = [];
      var appRate = [];
      var budgetSummary;
      var appShareValue;
      var fedShareValue;
      var message = {};
      var fedShareBreakDown;
      var appShareBreakDown = [];
      var numberOfPeriods = getNumberofPeriods(foConfig, fundingStreams);
      var percentageValue = _lodash.default.get(calculations, 'percentageValue', defaultPercentValue);
      appRate.push(percentageValue);
      budgetSummary = BudgetUtils.computeBudgetSummary(bocs, fundingStreams, numberOfPeriods, constructionProgramIncome, managementCostItemCodes, programIncome, foHandleProgIncome);
      if (budgetCalculationMode) {
        var appShareRate = [];
        var fedShareRate = [];
        for (i = 0; i < numberOfPeriods; i++) {
          appShareRate.push(percentageValue);
        }
        var budget = BudgetUtils.calculateBudget(budgetCalculationMode, numberOfPeriods, budgetSummary.totalCharges, fedShareRate, appShareRate, programIncome, foHandleProgIncome);
        fedShareBreakDown = budget.fedShare;
        appShareBreakDown = budget.appShare;
        fedRate = budget.fedShareRate;
        appRate = budget.appShareRate;
      } else {
        //Existing logic
        if (useRoundUpLogic && numberOfPeriods === 1) {
          appShareValue = _lodash.default.ceil((0, _utils.safeMult)(budgetSummary.totalCharges[0], (0, _utils.safeDivide)(percentageValue, (0, _utils.safeAddNoFixed)(1, percentageValue))), 2);
          appShareBreakDown.push(appShareValue);
        } else {
          for (var _i = 0; _i < numberOfPeriods; _i++) {
            appShareValue = _lodash.default.round((0, _utils.safeMult)(budgetSummary.totalCharges[_i], (0, _utils.safeDivide)(percentageValue, (0, _utils.safeAddNoFixed)(1, percentageValue))), 2);
            appShareBreakDown.push(appShareValue);
          }
        }
        fedShareBreakDown = BudgetUtils.getFedShareByAppShare(budgetSummary.totalCharges, appShareBreakDown);
        _lodash.default.map(fedShareBreakDown, function (fedShare, i) {
          fedRate.push(_lodash.default.round((0, _utils.safeDivide)(fedShare, budgetSummary.totalCharges[i]), 2));
        });
      }
      var reductions = _lodash.default.get(calculations, 'reductions');
      if (!_lodash.default.isEmpty(reductions)) {
        // this currently applies to passthrough fmag.
        // fed/app share needs to be calculated off (total - programIncome - reductions)
        // round appShare down round fedShare up
        // can't trust fedRate here due to direct math being different
        // (appRate is actually appRate/(1 + appRate) for direct)
        var fedShareTotal = _lodash.default.sum(_lodash.default.map(fedShareBreakDown, function (fedShare) {
          return parseFloat(fedShare);
        }));
        var appShareTotal = _lodash.default.sum(_lodash.default.map(appShareBreakDown, function (appShare) {
          return parseFloat(appShare);
        }));
        var totalPreReduction = (0, _utils.safeAdd)(fedShareTotal, appShareTotal);
        var totalPostProgramIncome = (0, _utils.safeSubstract)(totalPreReduction, programIncome);
        var reductionsData = _lodash.default.get(data, reductions);
        var totalPostReduction = _lodash.default.reduce(reductionsData, function (total, reduction) {
          return (0, _utils.safeSubstract)(total, reduction);
        }, totalPostProgramIncome);
        var newAppShare = _lodash.default.floor((0, _utils.safeMult)(totalPostReduction, appRate[0]), 2);
        var newFedShare = (0, _utils.safeSubstract)(totalPostReduction, newAppShare);

        // string expected for shares and rates
        // this assumes single entry array for fmag shares and rates
        // refactor if other passthrough ever needs to use this
        fedShareBreakDown = ["".concat(newFedShare)];
        appShareBreakDown = ["".concat(newAppShare)];
        fedRate = ["".concat(1 - appRate[0])];
        appRate = ["".concat(appRate[0])];
      }
      var fedShareLimit = _lodash.default.get(calculations, 'fedShareLimit');
      var limitMessage = _lodash.default.get(calculations, 'limitMessage');
      var applyCappedToAppShare = _lodash.default.get(calculations, 'applyCappedToAppShare', false);
      var fedShareLimitDifference = [];
      _lodash.default.reduce(fedShareBreakDown, function (sum, fedShareValue) {
        if (isFedSharePastLimit(fedShareLimit, (0, _utils.safeAdd)(fedShareValue, sum))) {
          fedShareLimitDifference.push((0, _utils.safeSubstract)((0, _utils.safeAdd)(fedShareValue, sum), fedShareLimit));
        }
        return (0, _utils.safeAdd)(fedShareValue, sum);
      }, 0);
      if (!_lodash.default.isEmpty(fedShareLimitDifference)) {
        var periodPastCap = numberOfPeriods - _lodash.default.size(fedShareLimitDifference);
        if (applyCappedToAppShare) {
          for (var i = 0; i < _lodash.default.size(fedShareBreakDown); i++) {
            appShareValue = appShareBreakDown[i];
            fedShareValue = fedShareBreakDown[i];
            if (i == periodPastCap) {
              var difference = fedShareLimitDifference[0];
              appShare.push((0, _utils.safeAdd)(appShareValue, difference));
              fedShare.push((0, _utils.safeSubstract)(fedShareValue, difference));
            } else if (i > periodPastCap) {
              appShare.push((0, _utils.safeAdd)(appShareValue, fedShareValue));
              fedShare.push(0);
            } else {
              appShare.push(appShareBreakDown[i]);
              fedShare.push(fedShareBreakDown[i]);
            }
          }
        } else {
          for (var i = 0; i < _lodash.default.size(fedShareBreakDown); i++) {
            if (i == periodPastCap) {
              fedShareValue = fedShareBreakDown[i];
              var _difference = fedShareLimitDifference[0];
              fedShare.push((0, _utils.safeSubstract)(fedShareValue, _difference));
            } else if (i > periodPastCap) {
              fedShare.push(0);
            } else {
              fedShare.push(fedShareBreakDown[i]);
            }
          }
          appShare = appShareBreakDown;
        }
        if (!_lodash.default.isEmpty(limitMessage)) {
          _lodash.default.set(message, 'type', limitMessage.type);
          _lodash.default.set(message, 'text', limitMessage.text);
        }
      } else {
        appShare = appShareBreakDown;
        fedShare = fedShareBreakDown;
      }
      var extras = {
        isEligible: true,
        message: message
      };
      if (budgetCalculationMode && budgetCalculationMode.reconcileAppShareWithAward === true) {
        extras.reconcileAppShareWithAward = budgetCalculationMode.reconcileAppShareWithAward;
        extras.reconcileAppShareAmount = budgetCalculationMode.reconcileAppShareAmount;
      }
      return {
        budgetSummary: budgetSummary,
        share: {
          appShare: appShare,
          fedShare: fedShare,
          fedRate: fedRate,
          appRate: appRate
        },
        extras: extras
      };
    };
    var applyRules = function applyRules(calcRules, defaultPercentValue, isEligible, budgetSummaryParams, data) {
      var budget = {};
      if ((!_lodash.default.isEmpty(calcRules) || defaultPercentValue) && isEligible) {
        var calculations = getCalculations(calcRules);
        budget = applyCalculations(calculations, defaultPercentValue, budgetSummaryParams, data);
      }
      return budget;
    };
    var rules = getRulesToApply(costShareRules, data);
    var calcRules = getCalcRulesToApply(rules, data);
    var defaultPercentValue = getDefaultPercentValue(rules);
    var inEligibleRule = findIneligibleRule(calcRules);
    var isEligible = inEligibleRule ? false : true;
    return applyRules(calcRules, defaultPercentValue, isEligible, budgetSummaryParams, data);
  },
  computeBudgetFromAppShare: function computeBudgetFromAppShare(bocs, fundingStreams, appShareByPeriod, defaultFedRates, rateAppliesTo, constructionProgramIncome, managementCostItemCodes, programIncome, foHandleProgIncome) {
    var calcTpc = true;
    var numPeriods = appShareByPeriod.length;
    var budgetSummary = BudgetUtils.computeBudgetSummary(bocs, fundingStreams, numPeriods, constructionProgramIncome, managementCostItemCodes, programIncome, foHandleProgIncome, calcTpc);
    var fedRate = BudgetUtils.getFedRateByAppShare(budgetSummary.totalCharges, appShareByPeriod, defaultFedRates, rateAppliesTo);
    var fedShare = [];
    if (_lodash.default.isEqual(foHandleProgIncome, PI_APPLICATION_TO_NON_FEDSHARE)) {
      calcTpc = false;
      var budgetSummaryOriginal = BudgetUtils.computeBudgetSummary(bocs, fundingStreams, numPeriods, constructionProgramIncome, managementCostItemCodes, programIncome, foHandleProgIncome, calcTpc);
      var appShareByPeriodWithPI = _lodash.default.cloneDeep(appShareByPeriod);
      var incomeTotal;
      if (_lodash.default.isArray(programIncome)) {
        incomeTotal = 0;
        for (var i = 0; i < programIncome.length; i++) {
          incomeTotal = incomeTotal + _lodash.default.toNumber(programIncome[i]);
        }
      }
      if (incomeTotal > 0) {
        for (var _i2 = 0; _i2 < numPeriods; _i2++) {
          if (programIncome[_i2]) {
            _lodash.default.set(appShareByPeriodWithPI, _i2, (0, _utils.safeAdd)(_lodash.default.get(appShareByPeriodWithPI, _i2), _lodash.default.toNumber(programIncome[_i2])));
          }
        }
      } else {
        _lodash.default.set(appShareByPeriodWithPI, numPeriods - 1, (0, _utils.safeAdd)(_lodash.default.get(appShareByPeriodWithPI, numPeriods - 1), programIncome));
      }
      fedShare = BudgetUtils.getFedShareByAppShare(budgetSummaryOriginal.totalCharges, appShareByPeriodWithPI, rateAppliesTo);
    } else {
      fedShare = BudgetUtils.getFedShareByAppShare(budgetSummary.totalCharges, appShareByPeriod, rateAppliesTo);
    }
    return {
      budgetSummary: budgetSummary,
      share: {
        fedRate: fedRate,
        fedShare: fedShare
      }
    };
  },
  getUpdatedTotalsByPeriod: function getUpdatedTotalsByPeriod(totalsByPeriod, foHandleProgIncome, programIncome) {
    var updatedTotalsByPeriod = totalsByPeriod;
    var lastUpdatedTotalsByPeriod = _lodash.default.get(updatedTotalsByPeriod, updatedTotalsByPeriod.length - 1);
    if (!(foHandleProgIncome == null)) {
      if (_lodash.default.isEqual(foHandleProgIncome, PI_DEDUCTION) || _lodash.default.isEqual(foHandleProgIncome, PI_APPLICATION_TO_NON_FEDSHARE)) {
        if (_lodash.default.isArray(programIncome)) {
          for (var i = 0; i < programIncome.length; i++) {
            updatedTotalsByPeriod[i] = (0, _utils.safeSubstract)(updatedTotalsByPeriod[i], _lodash.default.toNumber(programIncome[i]));
          }
        } else {
          updatedTotalsByPeriod[updatedTotalsByPeriod.length - 1] = (0, _utils.safeSubstract)(lastUpdatedTotalsByPeriod, programIncome);
        }
      }
    }
    return updatedTotalsByPeriod;
  },
  computeBudgetSummary: function computeBudgetSummary(bocs, fundingStreams, numPeriods, constructionProgramIncome, managementCostItemCodes, programIncome, foHandleProgIncome, calcTpc) {
    var directChargeBocs = _lodash.default.difference(bocs, INDIRECT_CHARGES_BOCS);
    var itemBocCharges = BudgetUtils.collectCosts(_lodash.default.fill(Array(numPeriods), []), {
      children: fundingStreams
    });
    var bocTotals = BudgetUtils.sumBocTotals(numPeriods, bocs, itemBocCharges, constructionProgramIncome);
    var totalsByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, bocs);
    var incomeTotal;
    if (_lodash.default.isArray(programIncome)) {
      incomeTotal = 0;
      for (var i = 0; i < programIncome.length; i++) {
        incomeTotal = incomeTotal + _lodash.default.toNumber(programIncome[i]);
      }
    }
    if (!(foHandleProgIncome == null) && !(programIncome == null) && (programIncome > 0 || incomeTotal > 0) && calcTpc) {
      var updatedTotalsByPeriod = BudgetUtils.getUpdatedTotalsByPeriod(totalsByPeriod, foHandleProgIncome, programIncome);
      totalsByPeriod = updatedTotalsByPeriod;
    }
    var directChargesByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, directChargeBocs);
    var indirectChargesByPeriod = BudgetUtils.sumChargesByPeriod(numPeriods, bocTotals, INDIRECT_CHARGES_BOCS);
    var budgetSummary = _objectSpread(_objectSpread({}, bocTotals), {}, {
      totalDirectCharges: directChargesByPeriod,
      totalIndirectCharges: indirectChargesByPeriod,
      totalCharges: totalsByPeriod
    });
    if (!_lodash.default.isEmpty(managementCostItemCodes)) {
      budgetSummary = _objectSpread(_objectSpread({}, budgetSummary), {}, {
        totalManagementCosts: BudgetUtils.sumTotalManagementCosts(fundingStreams, managementCostItemCodes, numPeriods)
      });
    }
    return budgetSummary;
  },
  roundToTheNearestCent: function roundToTheNearestCent(p) {
    var formattedNumber = (0, _utils.safeMult)(p, 1000);
    var truncatedFormattedNumber = Math.trunc(formattedNumber);
    var str = truncatedFormattedNumber.toString();
    var numberAtTheThounsands = _lodash.default.toNumber(str.charAt(str.length - 1));
    var centsAmount = _lodash.default.toNumber(str.substring(0, str.length - 1));
    var roundedNumber = (0, _utils.safeDivide)(centsAmount, 100);
    var paddedAmount = roundedNumber;
    if (numberAtTheThounsands >= 5) {
      paddedAmount = (0, _utils.safeAdd)(roundedNumber, 0.01);
    }
    return _lodash.default.toNumber(paddedAmount.toFixed(2));
  },
  roundUp: function roundUp(p) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var pArray = _lodash.default.split(_lodash.default.toString(p), '.');
    var toReturn = parseFloat(_lodash.default.join(pArray, '.'));
    if (_lodash.default.size(pArray) > 1) {
      var lastOne = _lodash.default.parseInt(_lodash.default.last(pArray).substr(0, pos));
      var decimalCond = _lodash.default.last(pArray);
      var lastOnePlusOne = lastOne + 1;
      // In case rounding up last number, ex. 9, or 99, or 999
      var comparator = '1';
      for (var i = 0; i < pos; i++) {
        comparator = comparator + '0';
      }
      comparator = _lodash.default.parseInt(comparator);
      if (lastOnePlusOne === comparator) {
        toReturn = parseFloat(_lodash.default.parseInt(_lodash.default.first(pArray).replace('.', '')) + 1);
      } else if (_lodash.default.parseInt(decimalCond.charAt(0)) === 0) {
        toReturn = Math.ceil(p * 100) / 100;
      } else if (decimalCond.charAt(1) === '') {
        toReturn = Math.ceil(p * 100) / 100;
      } else {
        toReturn = parseFloat(_lodash.default.join([_lodash.default.first(pArray), _lodash.default.toString(lastOnePlusOne)], '.'));
      }
    }
    return toReturn;
  },
  calculateBudget: function calculateBudget(budgetCalculationMode, numPeriods, totalShareArray, fedShareRateArray, appShareRateArray, budgetSummary, programIncome, foHandleProgIncome) {
    var budget = {
      appShareRate: appShareRateArray,
      fedShareRate: fedShareRateArray,
      appShare: [],
      fedShare: [],
      totalShare: totalShareArray
    };
    var calculatedTotalAppShare = 0;
    var total = (0, _utils.safeAddReduce)(totalShareArray, 0);
    for (var i = 0; i < numPeriods; i++) {
      //1. Calculate app share
      var calculatedAppRate = budget.appShareRate[i];
      if (budgetCalculationMode && budgetCalculationMode.deriveAppRate === true) {
        calculatedAppRate = (0, _utils.safeDivide)(budget.appShareRate[i], (0, _utils.safeAddNoFixed)(1, budget.appShareRate[i]));
      }
      var periodTotal = _lodash.default.multiply(budget.totalShare[i], calculatedAppRate);
      var roundedPeriodTotal = undefined;
      if (budgetCalculationMode && budgetCalculationMode.roundUp === true) {
        roundedPeriodTotal = BudgetUtils.roundUp(periodTotal, 2);
      } else if (budgetCalculationMode && budgetCalculationMode.roundToNearestCent === true) {
        roundedPeriodTotal = BudgetUtils.roundToTheNearestCent(periodTotal);
      } else {
        roundedPeriodTotal = _lodash.default.floor(periodTotal, 2);
      }
      if (budgetCalculationMode && budgetCalculationMode.reconcileAppShareWithAward === true) {
        var isActualNumber = _lodash.default.isNumber(budgetCalculationMode.reconcileAppShareAmount) && !_lodash.default.isNaN(budgetCalculationMode.reconcileAppShareAmount);
        if (isActualNumber) {
          roundedPeriodTotal = (0, _utils.safeAddNoFixed)(_lodash.default.toNumber(roundedPeriodTotal.toFixed(2)), budgetCalculationMode.reconcileAppShareAmount);
        }
      }
      budget.appShare[i] = _lodash.default.toNumber(roundedPeriodTotal.toFixed(2));
      calculatedTotalAppShare = (0, _utils.safeAddNoFixed)(calculatedTotalAppShare, budget.appShare[i]);

      //2. Reconciliate With Total if applicable
      if (budgetCalculationMode && i === numPeriods - 1) {
        var defaultAppRate = budget.appShareRate[i];
        if (budgetCalculationMode.defaultAppRate) {
          defaultAppRate = budgetCalculationMode.defaultAppRate;
        }
        var calculatedDefaultAppRate = defaultAppRate;
        if (budgetCalculationMode && budgetCalculationMode.deriveAppRate === true) {
          calculatedDefaultAppRate = (0, _utils.safeDivide)(defaultAppRate, (0, _utils.safeAddNoFixed)(1, defaultAppRate));
        }
        var expectedTotalAppShare = budgetCalculationMode.reconciliateWithTotal === true ? BudgetUtils.roundUp(_lodash.default.multiply(total, calculatedDefaultAppRate), 2) : budgetCalculationMode.roundToNearestCent === true ? BudgetUtils.roundToTheNearestCent(_lodash.default.multiply(total, calculatedDefaultAppRate), 2) : undefined;
        if (expectedTotalAppShare && calculatedTotalAppShare !== expectedTotalAppShare) {
          var reconciliationAmount = (0, _utils.safeSubstractNoFixed)(expectedTotalAppShare, calculatedTotalAppShare);
          if (budgetCalculationMode && budgetCalculationMode.reconcileAppShareWithAward === true) {
            reconciliationAmount = (0, _utils.safeAddNoFixed)(reconciliationAmount, budgetCalculationMode.reconcileAppShareAmount);
          }
          //If last budget summary period total is 0 , update the penultimate budget summary period total.
          if (i > 0 && budget.totalShare[i] == 0) {
            budget.appShare[i - 1] = (0, _utils.safeAdd)(budget.appShare[i - 1], reconciliationAmount);
            budget.fedShare[i - 1] = (0, _utils.safeSubstract)(budget.totalShare[i - 1], budget.appShare[i - 1]);
          } else {
            budget.appShare[i] = (0, _utils.safeAdd)(budget.appShare[i], reconciliationAmount);
          }
        }
      }

      //2. Calculate fedShare
      budget.fedShare[i] = (0, _utils.safeSubstract)(budget.totalShare[i], budget.appShare[i]);
    }
    if (fedShareRateArray.length === 0) {
      _lodash.default.map(budget.fedShare, function (fedShare, i) {
        fedShareRateArray.push(_lodash.default.round((0, _utils.safeDivide)(fedShare, budget.totalShare[i]), 2));
      });
    }
    budget.fedShareRate = fedShareRateArray;
    return budget;
  },
  getFedShareByAppShare: function getFedShareByAppShare(periodTotals, appShare) {
    return _lodash.default.map(periodTotals, function (periodTotal, i) {
      return (0, _utils.safeSubstract)(periodTotal, _lodash.default.get(appShare, i));
    });
  },
  getFedRateByAppShare: function getFedRateByAppShare(periodTotals, appShare, defaultFedRates, rateAppliesTo) {
    if (rateAppliesTo === 'federal') {
      // FP&S
      return _lodash.default.map(periodTotals, function (periodTotal, i) {
        if (periodTotal === 0) {
          return _lodash.default.get(defaultFedRates, i);
        } else {
          var appTotal = _lodash.default.get(appShare, i);
          var fedTotal = periodTotal - appTotal;
          return parseFloat(_lodash.default.round(1 - (0, _utils.safeDivide)(appTotal, fedTotal), RATE_PRECISION));
        }
      });
    } else {
      // SAFER
      return _lodash.default.map(periodTotals, function (periodTotal, i) {
        if (periodTotal === 0) {
          return _lodash.default.get(defaultFedRates, i);
        } else {
          return parseFloat(_lodash.default.round((0, _utils.safeDivide)(periodTotal - _lodash.default.get(appShare, i), periodTotal), RATE_PRECISION));
        }
      });
    }
  },
  getShareByPeriod: function getShareByPeriod(periodTotals, rates, rateAppliesTo) {
    if (rateAppliesTo === 'federal') {
      return _lodash.default.map(periodTotals, function (periodTotal, i) {
        var rate = _lodash.default.get(rates, i, 0);
        return _lodash.default.round((0, _utils.safeDivide)((0, _utils.safeMult)(periodTotal, rate), 1 + rate), 2);
      });
    } else {
      return _lodash.default.map(periodTotals, function (periodTotal, i) {
        return _lodash.default.round((0, _utils.safeMult)(periodTotal, _lodash.default.get(rates, i, 0)), 2);
      });
    }
  },
  collectCosts: function collectCosts(acc, obj) {
    if (obj !== undefined && !_lodash.default.get(obj, 'additionalInformation.ineligible')) {
      _lodash.default.forEach(_lodash.default.get(obj, COST_ATTRIBUTE), function (periodCosts, period) {
        return _lodash.default.set(acc, period, _lodash.default.concat(acc[period], periodCosts));
      });
      _lodash.default.forEach(obj.children, function (child) {
        return BudgetUtils.collectCosts(acc, child);
      });
    }
    return acc;
  },
  sumBocTotals: function sumBocTotals(numPeriods, bocs, totals, constructionProgramIncome) {
    var initBocTotals = _lodash.default.reduce(bocs, function (acc, boc) {
      return _lodash.default.set(acc, boc, _lodash.default.fill(Array(numPeriods), 0));
    }, {});
    var bocTotals = _lodash.default.reduce(totals, function (acc, periodTotal, period) {
      _lodash.default.forEach(periodTotal, function (cost) {
        if (_lodash.default.includes(bocs, _lodash.default.get(cost, 'boc'))) {
          var path = "".concat(cost.boc, ".").concat(period);
          _lodash.default.set(acc, path, (0, _utils.safeAdd)(_lodash.default.get(acc, path), (0, _utils.safeMult)(_lodash.default.get(cost, _constants.QUANTITY), _lodash.default.get(cost, _constants.PRICE))));
        }
      });
      return acc;
    }, initBocTotals);
    if (!_lodash.default.isEmpty(_lodash.default.get(bocTotals, 'construction')) && constructionProgramIncome) {
      var constructionTotal = (0, _utils.safeSubstract)(_lodash.default.get(bocTotals, 'construction.0'), constructionProgramIncome);
      constructionTotal = constructionTotal < 0 ? 0 : constructionTotal;
      bocTotals.construction[0] = constructionTotal;
    }
    return bocTotals;
  },
  sumChargesByPeriod: function sumChargesByPeriod(numPeriods, aggregatedTotals, bocs) {
    return _lodash.default.reduce(_lodash.default.range(numPeriods), function (periodTotals, period) {
      periodTotals.push(_lodash.default.reduce(bocs, function (total, boc) {
        return (0, _utils.safeAdd)(total, _lodash.default.get(aggregatedTotals, "".concat(boc, ".").concat(period)));
      }, 0));
      return periodTotals;
    }, []);
  },
  sumCharges: function sumCharges(aggregatedTotals, charges) {
    return _lodash.default.reduce(charges, function (acc, boc) {
      return (0, _utils.safeAdd)(acc, _lodash.default.reduce(_lodash.default.get(aggregatedTotals, boc), function (overall, total) {
        return (0, _utils.safeAdd)(overall, total);
      }));
    }, 0);
  },
  getDefaultAppShareRatesByActivity: function getDefaultAppShareRatesByActivity(fundingOpportunityConfigV2, fundingStreams) {
    var filteredConfigs = _lodash.default.filter(fundingOpportunityConfigV2, function (fundingStreamConfig) {
      var fundingStreamType = fundingStreamConfig.fundingStreamType;
      return _lodash.default.find(fundingStreams, {
        fundingStreamType: fundingStreamType
      }) !== undefined;
    });
    var appShareRates = {};
    _lodash.default.forEach(filteredConfigs, function (config) {
      _lodash.default.set(appShareRates, config.fundingStreamType, config.applicantCostShareRate);
    });
    return appShareRates;
  },
  getAppShareRatesBasedOn: function getAppShareRatesBasedOn(fundingOpportunityConfigV2, fundingStreams) {
    var filteredConfigs = _lodash.default.filter(fundingOpportunityConfigV2, function (fundingStreamConfig) {
      var fundingStreamType = fundingStreamConfig.fundingStreamType;
      return _lodash.default.find(fundingStreams, {
        fundingStreamType: fundingStreamType
      }) !== undefined;
    });
    var applicantCostShareBasedOn = {};
    _lodash.default.forEach(filteredConfigs, function (config) {
      if (!_lodash.default.isEmpty(config.applicantCostShareBasedOn) && !_lodash.default.isUndefined(config.applicantCostShareBasedOn)) {
        _lodash.default.set(applicantCostShareBasedOn, config.fundingStreamType, config.applicantCostShareBasedOn);
      }
    });
    return applicantCostShareBasedOn;
  },
  sumItemCodeTotals: function sumItemCodeTotals(totals) {
    var groupedByItemCode = _lodash.default.groupBy(totals, 'itemCode');
    var itemTotals = {};
    return _lodash.default.reduce(groupedByItemCode, function (acc, itemCode) {
      _lodash.default.forEach(itemCode, function (item) {
        if (_lodash.default.get(item, 'total')) {
          var path = "".concat(item.itemCode);
          _lodash.default.set(acc, "".concat(item.itemCode), (0, _utils.safeAdd)(_lodash.default.get(acc, path), item.total));
        }
      });
      return acc;
    }, itemTotals);
  },
  sumSubProgramTotals: function sumSubProgramTotals(totals) {
    var groupedBySubProgramFunding = _lodash.default.groupBy(totals, 'subProgramFunding');
    var itemTotals = {};
    return _lodash.default.reduce(groupedBySubProgramFunding, function (acc, subProgramFunding) {
      _lodash.default.forEach(subProgramFunding, function (item) {
        if (_lodash.default.get(item, 'total')) {
          var path = "".concat(item.subProgramFunding);
          _lodash.default.set(acc, path, (0, _utils.safeAdd)(_lodash.default.get(acc, path), item.total));
        }
      });
      return acc;
    }, itemTotals);
  },
  multiGroupBy: function multiGroupBy(seq, keys) {
    if (!keys.length) return seq;
    var first = keys[0];
    var rest = keys.slice(1);
    return _lodash.default.mapValues(_lodash.default.groupBy(seq, first), function (value) {
      return BudgetUtils.multiGroupBy(value, rest);
    });
  },
  sumSolutionAreaTotals: function sumSolutionAreaTotals(totals) {
    var groupedBySolutionArea = BudgetUtils.multiGroupBy(totals, ['solutionArea', 'subProgramFunding']);
    var itemTotals = {};
    return _lodash.default.reduce(groupedBySolutionArea, function (acc, solutionArea) {
      _lodash.default.forEach(solutionArea, function (items) {
        _lodash.default.forEach(items, function (item) {
          if (_lodash.default.get(item, 'total')) {
            var path = "".concat(item.subProgramFunding);
            _lodash.default.set(acc, "".concat(item.subProgramFunding), (0, _utils.safeAdd)(_lodash.default.get(acc, path), item.total));
          }
        });
      });
      return acc;
    }, itemTotals);
  },
  collectCostsWithItemCode: function collectCostsWithItemCode(acc, obj) {
    if (obj !== undefined && !_lodash.default.get(obj, 'additionalInformation.ineligible')) {
      _lodash.default.forEach(_lodash.default.get(obj, COST_ATTRIBUTE), function (costs, cost) {
        if (obj.itemCode) {
          var itemCost = _lodash.default.cloneDeep(costs[0]);
          itemCost.itemCode = obj.itemCode;
          _lodash.default.set(acc, cost, _lodash.default.concat(acc[cost], itemCost));
        } else {
          _lodash.default.set(acc, cost, _lodash.default.concat(acc[cost], costs));
        }
      });
      _lodash.default.forEach(obj.children, function (child) {
        return BudgetUtils.collectCostsWithItemCode(acc, child);
      });
    }
    return acc;
  },
  collectCostsWithSubProgram: function collectCostsWithSubProgram(acc, obj, orgIdPerformingWorkPath, appOrgId, filterByOrg) {
    var orgIdPerformingWork = _lodash.default.get(obj, orgIdPerformingWorkPath);
    if (orgIdPerformingWork && filterByOrg) {
      if (appOrgId !== orgIdPerformingWork) {
        _lodash.default.forEach(obj.children, function (child) {
          return BudgetUtils.collectCostsWithSubProgram(acc, child, orgIdPerformingWorkPath, appOrgId, filterByOrg);
        });
      }
    } else {
      _lodash.default.forEach(_lodash.default.get(obj, COST_ATTRIBUTE), function (costs, cost) {
        var itemCost = _lodash.default.cloneDeep(costs[0]);
        if (_lodash.default.get(obj, 'additionalInformation.subProgramFunding')) {
          itemCost.subProgramFunding = _lodash.default.get(obj, 'additionalInformation.subProgramFunding');
          _lodash.default.set(acc, cost, _lodash.default.concat(acc[cost], itemCost));
        }
      });
      if (obj !== undefined) {
        _lodash.default.forEach(obj.children, function (child) {
          return BudgetUtils.collectCostsWithSubProgram(acc, child, orgIdPerformingWorkPath, appOrgId, filterByOrg);
        });
      }
    }
    return acc;
  },
  filterContingenciesFromItemCodeTotals: function filterContingenciesFromItemCodeTotals(filterContingencies, itemCodeCharges, contingenciesItemCode) {
    return _lodash.default.filter(itemCodeCharges, function (item) {
      if (_lodash.default.get(item, 'itemCode')) {
        if (filterContingencies && item.itemCode !== contingenciesItemCode) {
          return item;
        } else if (!filterContingencies && item.itemCode === contingenciesItemCode) {
          return item;
        }
      }
    });
  },
  createReturnedItemCodeTotals: function createReturnedItemCodeTotals(itemCodes) {
    var returnValue = {};
    returnValue = _lodash.default.map(itemCodes, function (item) {
      return returnValue[item] = 0;
    });
    return returnValue;
  },
  computeBudgetSummaryByItemCode: function computeBudgetSummaryByItemCode(itemCodes, fundingStreams, programIncome) {
    var itemCodeCharges = _lodash.default.flattenDepth(BudgetUtils.collectCostsWithItemCode([], fundingStreams), 1);
    var contingenciesItemCode = parseInt(_lodash.default.findKey(itemCodes, function (item) {
      return item === 'contingencies';
    }));
    var itemCodeChargesWithoutContingencies = BudgetUtils.filterContingenciesFromItemCodeTotals(true, itemCodeCharges, contingenciesItemCode);
    var itemCodeTotals = BudgetUtils.sumItemCodeTotals(itemCodeChargesWithoutContingencies);
    var contingenciesCharges = BudgetUtils.filterContingenciesFromItemCodeTotals(false, itemCodeCharges, contingenciesItemCode);

    // returnedItemCodeTotals: totals for all items except contingencies
    var returnedItemCodeTotals = {};
    var itemCodesWithoutContingencies = _lodash.default.pickBy(itemCodes, function (item, key) {
      return key !== contingenciesItemCode.toString();
    });
    _lodash.default.forOwn(itemCodesWithoutContingencies, function (value, key) {
      returnedItemCodeTotals[value] = 0;
      _lodash.default.forOwn(itemCodeTotals, function (itemCodeValue, itemCodeKey) {
        if (key === itemCodeKey && key !== contingenciesItemCode) {
          returnedItemCodeTotals[value] = itemCodeValue;
        }
      });
    });
    var itemsSubtotal = _lodash.default.reduce(returnedItemCodeTotals, function (total, item) {
      return total + item;
    });
    var contingenciesCodeTotal = BudgetUtils.sumItemCodeTotals(contingenciesCharges);
    var contingenciesSubTotal = _lodash.default.reduce(contingenciesCodeTotal, function (total, item) {
      return total + item;
    });
    var itemsAndContingenciesSubTotal = (0, _utils.safeAdd)(itemsSubtotal, contingenciesSubTotal);
    var totalMinusProjectIncome = (0, _utils.safeSubstract)(itemsAndContingenciesSubTotal, programIncome);
    totalMinusProjectIncome = totalMinusProjectIncome < 0 ? 0 : totalMinusProjectIncome;
    return _objectSpread(_objectSpread({}, returnedItemCodeTotals), {}, {
      itemsSubtotal: itemsSubtotal,
      contingenciesSubTotal: contingenciesSubTotal,
      itemsAndContingenciesSubTotal: itemsAndContingenciesSubTotal,
      totalMinusProjectIncome: totalMinusProjectIncome
    });
  },
  computeBudgetSummaryByInvestment: function computeBudgetSummaryByInvestment(fundingStreams, orgId) {
    var matchingFundingStream = _lodash.default.filter(fundingStreams.children, function (stream) {
      return _lodash.default.includes(INVESTMENT, stream.fundingStreamType);
    });
    var managementCostFundingStream = _lodash.default.filter(fundingStreams.children, function (stream) {
      return _lodash.default.includes(MANAGEMENTCOSTS, stream.fundingStreamType);
    });
    var subProgramPassthroughCharges = _lodash.default.flattenDepth(BudgetUtils.collectCostsWithSubProgram([], matchingFundingStream[0], 'additionalInformation.orgIdPerformingWork', orgId, true), 1);
    var subProgramTotalCharges = _lodash.default.flattenDepth(BudgetUtils.collectCostsWithSubProgram([], matchingFundingStream[0], 'additionalInformation.orgIdPerformingWork', orgId, false), 1);
    var subProgramManagementCostCharges = _lodash.default.flattenDepth(BudgetUtils.collectCostsWithSubProgram([], managementCostFundingStream[0], 'additionalInformation.narrative.orgIdPerformingWork', orgId, false), 1);
    var subProgramPassthroughManagementCostCharges = _lodash.default.flattenDepth(BudgetUtils.collectCostsWithSubProgram([], managementCostFundingStream[0], 'additionalInformation.narrative.orgIdPerformingWork', orgId, true), 1);
    var subProgramPassthroughTotals = BudgetUtils.sumSubProgramTotals(subProgramPassthroughCharges);
    var subProgramInvestmentTotals = BudgetUtils.sumSubProgramTotals(subProgramTotalCharges);
    var subProgramManagementCostTotals = BudgetUtils.sumSubProgramTotals(subProgramManagementCostCharges);
    var subProgramPassthroughManagementCostTotals = BudgetUtils.sumSubProgramTotals(subProgramPassthroughManagementCostCharges);
    var subProgramTotals = {};
    subProgramTotals.totalPassthrough = subProgramPassthroughTotals;
    subProgramTotals.totalInvestments = subProgramInvestmentTotals;
    subProgramTotals.totalManagementCost = subProgramManagementCostTotals;
    subProgramTotals.totalPassthroughManagementCost = subProgramPassthroughManagementCostTotals;
    var solutionAreaTotals = BudgetUtils.sumSolutionAreaTotals(subProgramTotalCharges);
    return {
      subProgramTotals: subProgramTotals
    };
  },
  computeBudgetByItemCode: function computeBudgetByItemCode(itemCodes, fundingStreams, programIncome) {
    var budgetSummary = BudgetUtils.computeBudgetSummaryByItemCode(itemCodes, fundingStreams, programIncome);
    return {
      budgetSummary: budgetSummary
    };
  },
  computeBudgetByInvestments: function computeBudgetByInvestments(fundingStreams, orgId) {
    var budgetSummary = BudgetUtils.computeBudgetSummaryByInvestment(fundingStreams, orgId);
    return {
      budgetSummary: budgetSummary
    };
  },
  sumTotalManagementCosts: function sumTotalManagementCosts(fundingStreams, managementCostItemCodes, numPeriods) {
    var totalManagementCosts = _lodash.default.fill(Array(numPeriods), 0);
    _lodash.default.forEach(fundingStreams, function (child) {
      var children = _lodash.default.get(child, 'children', {});
      _lodash.default.forEach(children, function (item) {
        if (_lodash.default.includes(managementCostItemCodes, item.itemCode)) {
          var collectedCosts = BudgetUtils.collectCosts(_lodash.default.fill(Array(numPeriods), []), item);
          _lodash.default.forEach(collectedCosts, function (costs, index) {
            totalManagementCosts[index] = _lodash.default.reduce(costs, function (acc, cost) {
              return (0, _utils.safeAdd)(acc, (0, _utils.safeMult)(_lodash.default.get(cost, _constants.QUANTITY), _lodash.default.get(cost, _constants.PRICE)));
            }, totalManagementCosts[index]);
          });
        }
      });
    });
    return totalManagementCosts;
  },
  collectAncestorItems: function collectAncestorItems(acc, ancestorItemCode, obj) {
    if (obj === undefined) return;
    if (obj.itemCode && obj.itemCode == ancestorItemCode) {
      acc = _lodash.default.concat(acc, obj);
    } else if (obj.children) {
      _lodash.default.forEach(obj.children, function (childObj, idx) {
        acc = BudgetUtils.collectAncestorItems(acc, ancestorItemCode, childObj);
      });
    }
    return acc;
  },
  collectCostsFromAncestorsWithCostItemFieldValue: function collectCostsFromAncestorsWithCostItemFieldValue(ancestorItems, costItemFieldPath, costItemFieldBaseName) {
    var costItems = [];
    if (ancestorItems === undefined) return costItems;
    _lodash.default.forEach(ancestorItems, function (ancestorItem) {
      BudgetUtils.collectCostItemWithCostItemFieldValue(costItems, ancestorItem, costItemFieldPath, costItemFieldBaseName);
    });
    return _lodash.default.flattenDepth(costItems, 1);
  },
  collectCostItemWithCostItemFieldValue: function collectCostItemWithCostItemFieldValue(acc, obj, costItemFieldPath, costItemFieldBaseName) {
    if (obj === undefined) return acc;
    _lodash.default.forEach(_lodash.default.get(obj, COST_ATTRIBUTE), function (costs, costIdx) {
      // we're in the iterator so obj must have a cost, costItemFieldPath is relative to this obj
      var costItemFieldValue = _lodash.default.get(obj, costItemFieldPath);
      if (costItemFieldValue) {
        var itemCost = _lodash.default.cloneDeep(costs[0]);
        itemCost.itemCode = obj.itemCode;
        _lodash.default.set(itemCost, costItemFieldBaseName, costItemFieldValue);
        _lodash.default.set(acc, costIdx, _lodash.default.concat(acc[costIdx] ? acc[costIdx] : [], itemCost));
      }
    });
    _lodash.default.forEach(obj.children, function (childObj) {
      BudgetUtils.collectCostItemWithCostItemFieldValue(acc, childObj, costItemFieldPath, costItemFieldBaseName);
    });
    return acc;
  },
  sumByCostItemFieldValue: function sumByCostItemFieldValue(costItems, valueToFieldMap, costItemFieldBaseName) {
    var costItemsByCostClass = _lodash.default.groupBy(costItems, function (item) {
      var fieldName = valueToFieldMap[_lodash.default.get(item, costItemFieldBaseName)];
      return fieldName ? fieldName : 'unknown';
      // if there are values saved to "unknown" then the valueToFieldMap does not
      // contain the values being saved in the app's funding stream
    });

    var totalsByFieldValue = {};
    _lodash.default.forEach(_lodash.default.values(valueToFieldMap), function (fldName) {
      var fldCostItems = _lodash.default.get(costItemsByCostClass, fldName, []);
      var total = _lodash.default.reduce(fldCostItems, function (acc, costItem) {
        return (0, _utils.safeAdd)(_lodash.default.get(costItem, 'total', 0), acc);
      }, 0);
      _lodash.default.set(totalsByFieldValue, fldName, total);
    });
    return totalsByFieldValue;
  },
  /*
   * ancestorItemCode - for construction it is the construction item code being used (556)
   * costItemFieldPath - is the object path relative to the object containing the cost.
   *   E.g., to group cost by cost classification, you pass "additionalInformation.costClassification"
   * costItemFieldValueToFieldNameMap - is used to specify the name of the field in the totals object being returned
   *   for a given value of the field being grouped by. For example, one of the additionalInformation.costClassification field
   *   values is "Administrative and legal expenses" and we want to save totals for all costs associated with that value into
   *   the field named "administrativeAndLegalExpenses".
   * fundingStreams - like the other functions is object with { children: [ ...${appData.fundingStreams} ]}
   */
  computeConstructionBudgetSummaryByCostItemField: function computeConstructionBudgetSummaryByCostItemField(ancestorItemCode, costItemFieldPath, costItemFieldValueToFieldNameMap, fundingStreams) {
    if (!ancestorItemCode || !costItemFieldPath || !costItemFieldValueToFieldNameMap || !fundingStreams) return {};
    var costItemFieldBaseName = _lodash.default.last(_lodash.default.split(costItemFieldPath, '.')); // additionalInformation.costClassification => costclassification
    /*
     * Pluck from the fundingStreams hierarchy of data those nodes with an itemCode == ancestorItemCode
     * under which there costs we need to sum, and we can ignore costs under other nodes.
     */
    var constructionItems = BudgetUtils.collectAncestorItems([], ancestorItemCode, fundingStreams);
    var budgetSummary = BudgetUtils.collectCostsWithCostItemFieldValues(constructionItems, costItemFieldPath, costItemFieldBaseName, costItemFieldValueToFieldNameMap);
    return budgetSummary;
  },
  /*
   * As above (computeConstructionBudgetSummaryByCostItemField) but this method does not filter on ancestor Item code.
   * costItemFieldPath - is the object path relative to the object containing the cost.
   *   E.g., to group cost by cost classification, you pass "additionalInformation.costClassification"
   * costItemFieldValueToFieldNameMap - is used to specify the name of the field in the totals object being returned
   *   for a given value of the field being grouped by. For example, one of the additionalInformation.costClassification field
   *   values is "Administrative and legal expenses" and we want to save totals for all costs associated with that value into
   *   the field named "administrativeAndLegalExpenses".
   * fundingStreams - like the other functions is object with { children: [ ...${appData.fundingStreams} ]}
   */
  computeConstructionBudgetSummaryByCostItemFieldNoAncestor: function computeConstructionBudgetSummaryByCostItemFieldNoAncestor(costItemFieldPath, costItemFieldValueToFieldNameMap, fundingStreams) {
    if (!costItemFieldPath || !costItemFieldValueToFieldNameMap || !fundingStreams) return {};
    var costItemFieldBaseName = _lodash.default.last(_lodash.default.split(costItemFieldPath, '.')); // additionalInformation.costClassification => costclassification

    var budgetSummary = BudgetUtils.collectCostsWithCostItemFieldValues(fundingStreams.children, costItemFieldPath, costItemFieldBaseName, costItemFieldValueToFieldNameMap);
    return budgetSummary;
  },
  /*
   * Cycles through array of funding streams (constructionItems) and sums based on
   * cost classification, keeps contingencies separate from subtotal
   * returns budgetSummary
   */
  collectCostsWithCostItemFieldValues: function collectCostsWithCostItemFieldValues(constructionItems, costItemFieldPath, costItemFieldBaseName, costItemFieldValueToFieldNameMap) {
    /*
     * Extract the cost data underneath each of the constructionItem nodes and add to that data
     * the value found at costItemFieldPath in object containing the cost. For example, if costItemFieldPath is
     * "additionalInformation.costClassification" we want to find the object in hierarchy containing a
     * "cost" field (e.g., {"cost": [[ {boc: 'construction', price: '9.95', quantity: 10, total: 99.50} ]], ... }),
     * and value at {additionalInformation: {costClassification: "Site work", ...}, ...}, and add value ("Site Work")
     * to the cost object, like so {boc: 'construction', price: '9.95', quantity: 10, total: 99.50, costClassification: "Site work"},
     * and return array full of these individual cost items.
     */
    var costItems = BudgetUtils.collectCostsFromAncestorsWithCostItemFieldValue(constructionItems, costItemFieldPath, costItemFieldBaseName);

    /*
     * calculate totals based upon values found at costItemFieldPath,
     * for construction we need to pull out contingencies on its own as it is displayed after subtotal of other items.
     * Also calculate the various totals for the return object.
     */
    var totalsByCostClass = BudgetUtils.sumByCostItemFieldValue(costItems, costItemFieldValueToFieldNameMap, costItemFieldBaseName);
    var contingenciesSubTotal = _lodash.default.get(totalsByCostClass, 'contingencies');
    var totalsByCostClassWithoutContingencies = _lodash.default.omit(totalsByCostClass, 'contingencies');
    var itemsSubtotal = _lodash.default.reduce(totalsByCostClassWithoutContingencies, function (acc, cost) {
      return (0, _utils.safeAdd)(acc, cost);
    }, 0);
    var itemsAndContingenciesSubTotal = itemsSubtotal + contingenciesSubTotal;
    // project income not used in this calculation nor displayed on component that renders this data for HSGP (GMMGO-44638)
    var totalMinusProjectIncome = itemsAndContingenciesSubTotal;
    return {
      budgetSummary: _objectSpread(_objectSpread({}, totalsByCostClassWithoutContingencies), {}, {
        itemsSubtotal: itemsSubtotal,
        contingenciesSubTotal: contingenciesSubTotal,
        itemsAndContingenciesSubTotal: itemsAndContingenciesSubTotal,
        totalMinusProjectIncome: totalMinusProjectIncome
      })
    };
  },
  /*
   * If obj contains the fieldPath (e.g., "additionalInformation.nationalPriorityArea") then append
   * it to the acc array/accumulator and return that array.  If obj does not contain fieldPath and
   * does contain children, then iterate through each of the children looking for the path
   */
  collectItemsContainingFieldPath: function collectItemsContainingFieldPath(acc, fieldPath, obj) {
    if (obj === undefined) return acc;
    if (_lodash.default.get(obj, fieldPath)) {
      acc = _lodash.default.concat(acc, obj);
    } else if (obj.children) {
      _lodash.default.forEach(obj.children, function (childObj) {
        acc = BudgetUtils.collectItemsContainingFieldPath(acc, fieldPath, childObj);
      });
    } else if (_lodash.default.isArray(obj)) {
      _lodash.default.forEach(obj, function (childObj) {
        acc = BudgetUtils.collectItemsContainingFieldPath(acc, fieldPath, childObj);
      });
    }
    return acc;
  },
  /*
   * Iterate through itemsWithFieldPath collection, all of which should have a value at fieldPath,
   * retrieve that value and pass it along with the individual item with that value, to a function
   * that will retrieve all the costItem objects (obj w/ boc, quantity, price, total props) and
   * add to each of those the value found at fieldPath (as groupByValue property) along with
   * the subProgramFunding value of the costItem.  Return array full of these objects
   */
  collectCostItemsFromItemsWithFieldPath: function collectCostItemsFromItemsWithFieldPath(fieldPath, itemsWithFieldPath, includeSubProgramFunding) {
    var costItems = [];
    _lodash.default.forEach(itemsWithFieldPath, function (item) {
      var groupByFieldValue = _lodash.default.get(item, fieldPath, 'unknown'); // there should be no "unknowns" in array provided
      if (includeSubProgramFunding === 'false' || !includeSubProgramFunding) {
        BudgetUtils.collectCostItemsInObjectAddFieldPathValue(costItems, groupByFieldValue, item);
      } else {
        BudgetUtils.collectCostItemsInObjectAddFieldPathValueAndSubProgram(costItems, groupByFieldValue, item);
      }
    });
    return _lodash.default.flattenDepth(costItems, 1);
  },
  collectCostItemsInObjectAddFieldPathValueAndSubProgram: function collectCostItemsInObjectAddFieldPathValueAndSubProgram(acc, fieldPathValue, item) {
    if (item === undefined) return acc;
    _lodash.default.forEach(_lodash.default.get(item, COST_ATTRIBUTE), function (costs, costIdx) {
      // we're in the iterator so obj must have a cost, costItemFieldPath is relative to this obj
      var subProgramFunding = _lodash.default.get(item, 'additionalInformation.subProgramFunding');
      if (subProgramFunding) {
        var itemCost = _lodash.default.cloneDeep(costs[0]);
        itemCost.itemCode = item.itemCode;
        itemCost.subProgramFunding = subProgramFunding;
        _lodash.default.set(itemCost, 'groupByValue', fieldPathValue);
        _lodash.default.set(acc, costIdx, _lodash.default.concat(acc[costIdx] ? acc[costIdx] : [], itemCost));
      }
    });
    _lodash.default.forEach(item.children, function (childObj) {
      BudgetUtils.collectCostItemsInObjectAddFieldPathValueAndSubProgram(acc, fieldPathValue, childObj);
    });
  },
  /*
   * Sum up the total costs in the costItems by groupByValue as well as subProgramFunding for costs haveing the group by value
   * costItems is array with objects such as the following
   * eg. [{boc: "other", quantity: 1, price: "1.00", total: 1, groupByValue: "Enhancing cybersecurity", subProgramFunding: "SHSP"}, ...]
   * output will be an object with keys for each value in groupByValueList.  If there are no costItems for a value in that list
   * an output object with all 0 dollars is created.  A grand total object is created as well
   * e.g. {
   *   groupByValues: {
   *     "Enhancing cybersecurity": {SHSP: 1, UASI: 0, OPSG: 0, total: 1},
   *     "Enhancing election security": {SHSP: 0, UASI: 0, OPSG: 0, total: 0},
   *      ...
   *   },
   *   totalValues: { SHSP: 59, UASI: 98, OPSG: 77, total: 234}
   * }
   */
  sumByFieldPathValueAndSubProgramFunding: function sumByFieldPathValueAndSubProgramFunding(costItems, groupByValueList) {
    var costItemsByGroupByValue = _lodash.default.groupBy(costItems, function (item) {
      return _lodash.default.get(item, 'groupByValue', 'unknown');
    });
    var costItemsByGroupByValueBySubprogramFunding = {};
    _lodash.default.forEach(_lodash.default.keys(costItemsByGroupByValue), function (groupByValue) {
      var groupedByArray = costItemsByGroupByValue[groupByValue];
      var subProgGroupBy = _lodash.default.groupBy(groupedByArray, function (item) {
        var subProgFund = 'NONE';
        switch (_lodash.default.get(item, 'subProgramFunding', 'unkonwn')) {
          case 'SHSP':
          case 'SHSPForSHSP':
          case 'SHSPForOPSG':
            subProgFund = 'SHSP';
            break;
          case 'UASI':
          case 'UASIForUASI':
            subProgFund = 'UASI';
            break;
          case 'OPSG':
          case 'OPSGForOPSG':
            subProgFund = 'OPSG';
            break;
        }
        return subProgFund;
      });
      _lodash.default.set(costItemsByGroupByValueBySubprogramFunding, groupByValue, subProgGroupBy);
    });
    var groupByValueTotals = {};
    var grandTotals = {
      SHSP: 0,
      UASI: 0,
      OPSG: 0,
      total: 0
    };
    _lodash.default.forEach(groupByValueList, function (groupByValue) {
      var costItemsByGroupByValue = costItemsByGroupByValueBySubprogramFunding[groupByValue];
      var totalsObj = {};
      if (!costItemsByGroupByValue) {
        totalsObj['SHSP'] = 0;
        totalsObj['UASI'] = 0;
        totalsObj['OPSG'] = 0;
        totalsObj['total'] = 0;
        _lodash.default.set(groupByValueTotals, groupByValue, totalsObj);
      } else {
        var groupValueTotal = 0;
        _lodash.default.forEach(['SHSP', 'UASI', 'OPSG', 'NONE'], function (subProgFund) {
          var costItemsForSubProg = costItemsByGroupByValue[subProgFund];
          var total = _lodash.default.reduce(costItemsForSubProg, function (acc, costItem) {
            return (0, _utils.safeAdd)(acc, _lodash.default.get(costItem, 'total'));
          }, 0);
          _lodash.default.set(totalsObj, subProgFund, total);
          groupValueTotal = (0, _utils.safeAdd)(groupValueTotal, total);
        });
        _lodash.default.set(totalsObj, 'total', groupValueTotal);
        grandTotals['total'] = (0, _utils.safeAdd)(grandTotals['total'], groupValueTotal);
        grandTotals['SHSP'] = (0, _utils.safeAdd)(grandTotals['SHSP'], totalsObj['SHSP']);
        grandTotals['UASI'] = (0, _utils.safeAdd)(grandTotals['UASI'], totalsObj['UASI']);
        grandTotals['OPSG'] = (0, _utils.safeAdd)(grandTotals['OPSG'], totalsObj['OPSG']);
        _lodash.default.set(groupByValueTotals, groupByValue, totalsObj);
      }
    });
    return {
      groupByValues: groupByValueTotals,
      totalValues: grandTotals
    };
  },
  collectCostItemsInObjectAddFieldPathValue: function collectCostItemsInObjectAddFieldPathValue(acc, fieldPathValue, item) {
    if (item === undefined) return acc;
    _lodash.default.forEach(_lodash.default.get(item, COST_ATTRIBUTE), function (costs, costIdx) {
      var itemCost = _lodash.default.cloneDeep(costs[0]);
      itemCost.itemCode = item.itemCode;
      _lodash.default.set(itemCost, 'groupByValue', fieldPathValue);
      _lodash.default.set(acc, costIdx, _lodash.default.concat(acc[costIdx] ? acc[costIdx] : [], itemCost));
    });
    _lodash.default.forEach(item.children, function (childObj) {
      BudgetUtils.collectCostItemsInObjectAddFieldPathValue(acc, fieldPathValue, childObj);
    });
  },
  computeBudgetSummaryByNamedFieldPath: function computeBudgetSummaryByNamedFieldPath(fieldPath, fieldValueList, fundingStreams, includeSubProgramFunding) {
    /*
     * Look through fundingStreams item hierarchy to find those items containing the object path specified
     * by fieldPath and add them to the array/accumulator returning all those items found.
     */
    var itemsWithFieldPath = BudgetUtils.collectItemsContainingFieldPath([], fieldPath, fundingStreams);
    /*
     * Collect all the cost items found in or underneath the items containing the fieldPath.
     * Add to the cost object ( {boc: ..., quanity: ..., price: ..., total: ...}) a groupByValue property
     * w/ value of fieldPath.  Also add a subProgramFunding property with a normalized value (e.g., SHSPForOPSG to SHSP)
     */
    var costItems = BudgetUtils.collectCostItemsFromItemsWithFieldPath(fieldPath, itemsWithFieldPath, includeSubProgramFunding);
    /*
     *  create the budgetSummary object to be returned
     */
    var budgetSummary = BudgetUtils.sumByFieldPathValueAndSubProgramFunding(costItems, fieldValueList);
    return {
      budgetSummary: budgetSummary
    };
  }
};
exports.BudgetUtils = BudgetUtils;